var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g, _path42, _path43, _path44, _g2, _path45, _path46, _path47, _g3, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g4, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoresultglobalsearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 382.4H0v.25h500v-.25zM435.67 398.49h-18.89v.25h18.89v-.25zM322.52 396.75h-29.47v.25h29.47v-.25zM415.78 389.21h-47.11v.25h47.11v-.25zM63.43 390.89H52.46v.25h10.97v-.25zM110.89 390.89H72.33v.25h38.56v-.25zM225.15 395.11H171v.25h54.15v-.25zM237 337.8H43.92a5.713 5.713 0 0 1-5.71-5.71V60.66A5.71 5.71 0 0 1 43.92 55H237a5.712 5.712 0 0 1 5.71 5.71v271.38a5.715 5.715 0 0 1-1.672 4.038A5.715 5.715 0 0 1 237 337.8zM43.92 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.472 5.472 0 0 0 5.46 5.46H237a5.473 5.473 0 0 0 5.46-5.46V60.66A5.473 5.473 0 0 0 237 55.2H43.92zM453.31 337.8h-193.1a5.724 5.724 0 0 1-4.035-1.675 5.724 5.724 0 0 1-1.675-4.035V60.66a5.72 5.72 0 0 1 5.71-5.66h193.1a5.71 5.71 0 0 1 5.69 5.66v271.43a5.71 5.71 0 0 1-5.69 5.71zM260.21 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.473 5.473 0 0 0 5.46 5.46h193.1a5.473 5.473 0 0 0 5.46-5.46V60.66a5.473 5.473 0 0 0-5.46-5.46h-193.1z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M435.67 398.49h-18.89v.25h18.89v-.25zM322.52 396.75h-29.47v.25h29.47v-.25zM415.78 389.21h-47.11v.25h47.11v-.25zM63.43 390.89H52.46v.25h10.97v-.25zM110.89 390.89H72.33v.25h38.56v-.25zM225.15 395.11H171v.25h54.15v-.25z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196.94 85.62h-59.38v135.04h59.38V85.62z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.57 85.62h-59.38v135.04h59.38V85.62z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M194.06 214.58V91.7H147.7v122.88h46.36z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.05 214.58V91.7h-2.74v122.88h2.74z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.87 178.09h-53.99v8.16h53.99v-8.16zM197.87 102.42h-53.99v8.16h53.99v-8.16z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M277 85.62h-59.38v135.04H277V85.62z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.62 85.62h-59.38v135.04h59.38V85.62z",
    fill: "#F5F5F5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M274.11 214.58V91.7h-46.36v122.88h46.36z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M274.11 214.58V91.7h-2.74v122.88h2.74z",
    fill: "#E6E6E6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M277.93 178.09h-53.99v8.16h53.99v-8.16zM277.93 102.42h-53.99v8.16h53.99v-8.16z",
    fill: "#F5F5F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.88 85.62H57.5v135.04h59.38V85.62z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.51 85.62H61.13v135.04h59.38V85.62z",
    fill: "#F5F5F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114 214.58V91.7H67.64v122.88H114z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.99 214.57V91.69h-2.74v122.88h2.74z",
    fill: "#E6E6E6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M117.81 178.09H63.82v8.16h53.99v-8.16zM117.81 102.42H63.82v8.16h53.99v-8.16z",
    fill: "#F5F5F5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M329.22 247.51h-9.71V382.4h9.71V247.51z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M331.82 247.51h-5.72V382.4h5.72V247.51z",
    fill: "#F0F0F0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.71 257.62h137.88V247.5H195.71v10.12z",
    fill: "#F0F0F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M65.11 247.51H55.4V382.4h9.71V247.51z",
    fill: "#E6E6E6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.93 247.51h-5.72V382.4h5.72V247.51z",
    fill: "#F0F0F0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M53.67 257.62h137.88V247.5H53.67v10.12z",
    fill: "#E6E6E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M194.88 247.51h-9.71V382.4h9.71V247.51z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.48 247.51h-5.72V382.4h5.72V247.51z",
    fill: "#F0F0F0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M170.17 202.64h72l5.65 42.51h-71.99l-5.66-42.51zM175.83 245.15l.29 2.35h72l-.29-2.35h-72z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M172.39 202.64h71.99l5.66 42.51h-72l-5.65-42.51z",
    fill: "#F0F0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.78 243.21l-5.13-38.63h67.99l5.14 38.63h-68z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M196.8 245.15l.29 2.35h79.29l-.3-2.35H196.8z",
    fill: "#F0F0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M326.9 211h-35.64a24.798 24.798 0 0 0-24.82 21.63L261.23 272l-19.36-.07h-.06a16.86 16.86 0 0 0-17.21 15.57l-1.14 13.5a8.645 8.645 0 0 0-7.37 7.47h95.61a24.776 24.776 0 0 0 24.8-21.61l7.5-56.5a17.333 17.333 0 0 0-10.036-17.805A17.325 17.325 0 0 0 326.9 211zm-84 89.86h-14.3l1.08-12.42a12.44 12.44 0 0 1 12.7-11.52h.05l18.16.06-1.27 9.57a16.41 16.41 0 0 1-16.45 14.31h.03z",
    fill: "#E0E0E0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M238.17 308.43h-4.96l-11.62 73.97h4.96l11.62-73.97zM256.79 308.43h-4.96L240.2 382.4h4.96l11.63-73.97zM300.47 308.43h4.96l11.63 73.97h-4.96l-11.63-73.97zM281.86 308.43h4.96l11.62 73.97h-4.96l-11.62-73.97z",
    fill: "#F0F0F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M439.61 87.99h-96.69V290h96.69V87.99z",
    fill: "#E6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M446.33 87.99H344.71V290h101.62V87.99z",
    fill: "#F0F0F0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M437.81 281.49V96.51h-84.6v184.98h84.6z",
    fill: "#FAFAFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M383.21 281.49L393.69 96.5h14.14l-10.48 184.99h-14.14zM400.02 281.49L410.5 96.5h14.14l-10.48 184.99h-14.14z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M250 427.56c107.082 0 193.89-5.068 193.89-11.32 0-6.252-86.808-11.32-193.89-11.32-107.082 0-193.89 5.068-193.89 11.32 0 6.252 86.808 11.32 193.89 11.32z",
    fill: "#F5F5F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M240.81 121.6L225.3 348.09h189.12l17.13-250.22H266.17l-25.36 23.73z",
    fill: "#4E667D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M240.81 121.6L225.3 348.09h189.12l17.13-250.22H266.17l-25.36 23.73z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M398.944 174.336c12.74-12.312 13.747-31.938 2.249-43.837-11.498-11.898-31.148-11.563-43.888.749-12.741 12.312-13.748 31.938-2.249 43.837 11.498 11.898 31.147 11.563 43.888-.749z",
    fill: "#4E667D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M397.846 173.2c12.069-11.663 13.024-30.255 2.132-41.526-10.892-11.271-29.506-10.953-41.575.71-12.069 11.663-13.024 30.255-2.132 41.526 10.892 11.271 29.506 10.953 41.575-.71z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 348,
    y: 123,
    width: 60,
    height: 60
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M397.846 173.2c12.069-11.663 13.024-30.255 2.132-41.526-10.892-11.271-29.506-10.953-41.575.71-12.069 11.663-13.024 30.255-2.132 41.526 10.892 11.271 29.506 10.953 41.575-.71z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.41 163l-5.78-.38s-2.69 13.84-4.41 15c-2.35 1.63-7 5.57-10.09 7a5.61 5.61 0 0 0-.19 2.91c4.8 0 13.68-4.78 15.21-6.86 3.51-4.67 5.26-17.67 5.26-17.67z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.17 154.32c1.75 3.26-3.7 15-3.7 15l-7.42-2.32a31.368 31.368 0 0 1 2.47-10.48c1.84-3.83 6.73-5.78 8.65-2.2z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M367.5 160.32c1 2.36-.31 8.06-1.34 11.67-2.51-4.3-2.86-8.3 1.34-11.67z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.47 154.9c-1.14 4.17-3.38 15.12-1.55 32.31h19.53c.45-3.27-.12-19.24 4.47-34.65a52.091 52.091 0 0 0-7.05-.9 78.24 78.24 0 0 0-9.06 0 21.82 21.82 0 0 0-3.81.7 3.614 3.614 0 0 0-2.53 2.54z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M384.94 156.36c-.59 2.54-.36 8.61 1.41 15.63a105.15 105.15 0 0 1 3.13-17.9c-1.39-.17-3.98-.09-4.54 2.27z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.47 143.18c-.84 2.92-1.46 6.53.4 8.48 0 0-1.45 3-6.86 3-4.95 0-2.2-3-2.2-3 3.32-.78 3.53-4.8 3.17-7.06l5.49-1.42z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 154.61c.505.847.774 1.814.78 2.8 0 0 7-2.39 7-5.9 0 0-.91-.57-1.48-1 .02-.03-.45 2.7-6.3 4.1zM375.81 154.61a7.325 7.325 0 0 0-1.38 2.59 4.889 4.889 0 0 1-1.63-5.54c.581-.233 1.18-.42 1.79-.56 0 0-.85 2.76 1.22 3.51z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M377 144.6a8.833 8.833 0 0 1-.47 4.78 5.392 5.392 0 0 0 1.49-.44c1.92-.87 2.95-2.23 4.08-4.24.11-.52.25-1 .39-1.52L377 144.6z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.25 141.9a3.333 3.333 0 0 0 1.83 2c1.17.5 2-.57 1.93-1.8-.07-1.23-.81-2.71-2.1-2.69a1.862 1.862 0 0 0-1.757 1.634 1.86 1.86 0 0 0 .097.856z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M372.25 141.9a3.333 3.333 0 0 0 1.83 2c1.17.5 2-.57 1.93-1.8-.07-1.23-.81-2.71-2.1-2.69a1.862 1.862 0 0 0-1.757 1.634 1.86 1.86 0 0 0 .097.856z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.48 133.73c-.38-2.31-3.79 1.75-3.06 3.89s3.48-1.29 3.06-3.89z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.78 139.59c-1.25 3.87-1.79 6.18-4.24 7.84a4.866 4.866 0 0 1-5.246.431 4.872 4.872 0 0 1-2.574-4.591c.1-3.66 2.13-9.37 6.27-10.27 4.14-.9 7.01 2.72 5.79 6.59z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.64 137.3c-4.22-.6-10.28-1.38-8.08-4.83 2.09-3.29 10.43-2.69 7.9-1.23 3.27.19 7.43 1.76 4.29 2.84 2.53 1.8 1.53 6.62-3.3 8.3-1.39-2.02-2.45-2.91-.81-5.08z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.38 144.2a4.137 4.137 0 0 1-2.69 1.24c-1.32.07-1.57-1.19-.86-2.28.71-1.09 2.09-2.2 3.25-1.75 1.16.45 1.19 1.87.3 2.79z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.71 139.67c-.08.32-.31.54-.52.51-.21-.03-.3-.32-.21-.64s.31-.55.51-.51c.2.04.31.32.22.64zM375.2 139.05c-.08.32-.31.55-.51.51-.2-.04-.3-.32-.22-.64.08-.32.31-.54.52-.51.21.03.3.32.21.64z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.28 139.41a13.263 13.263 0 0 1-2.2 2.46 1.7 1.7 0 0 0 1.41.54l.79-3z",
    fill: "#ED847E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.17 143.45a.08.08 0 0 1-.033-.014.107.107 0 0 1-.026-.026.082.082 0 0 1-.012-.034.087.087 0 0 1 .001-.036.117.117 0 0 1 .047-.06.124.124 0 0 1 .073-.02 2.723 2.723 0 0 0 2.26-.63.09.09 0 0 1 .065-.028c.012 0 .024.003.035.007a.103.103 0 0 1 .059.091.103.103 0 0 1-.029.07 2.879 2.879 0 0 1-2.44.68zM380.07 138.69a.156.156 0 0 1-.074-.033.155.155 0 0 1-.046-.067 1.34 1.34 0 0 0-1-.83.16.16 0 0 1-.15-.2.213.213 0 0 1 .078-.127.212.212 0 0 1 .142-.043 1.655 1.655 0 0 1 1.29 1c.017.048.015.1-.006.147a.198.198 0 0 1-.104.103.173.173 0 0 1-.13.05zM374 137.5a.105.105 0 0 1-.07 0 .176.176 0 0 1-.055-.13.176.176 0 0 1 .055-.13 2.062 2.062 0 0 1 1.63-.73.175.175 0 0 1 .067.025.17.17 0 0 1 .052.048c.014.02.024.042.03.066a.188.188 0 0 1 .001.071.209.209 0 0 1-.082.13.205.205 0 0 1-.148.04 1.643 1.643 0 0 0-1.28.59.183.183 0 0 1-.097.041.184.184 0 0 1-.103-.021z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64 157.91l-5.29 2.81s5.11 12.6 4.24 14.49c-1.19 2.58-3.16 8.25-5.1 11.06a5.111 5.111 0 0 0 1.41 2.46c4.24-2.56 9.45-11.21 9.68-13.71.52-5.71-4.94-17.11-4.94-17.11z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.92 152.56c3.7.65 6.42 13.83 6.42 13.83l-9.12 2.61a67.685 67.685 0 0 1-3.21-9.34c-1.21-4.88 1.99-7.81 5.91-7.1z",
    fill: "#263238"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M388.879 321.397c12.74-12.312 13.747-31.938 2.249-43.837-11.498-11.898-31.148-11.563-43.888.749-12.74 12.312-13.747 31.938-2.249 43.837 11.498 11.898 31.148 11.563 43.888-.749z",
    fill: "#4E667D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M387.781 320.251c12.069-11.663 13.024-30.255 2.132-41.526-10.892-11.271-29.506-10.953-41.575.71-12.069 11.663-13.024 30.255-2.132 41.526 10.892 11.271 29.506 10.953 41.575-.71z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 338,
    y: 270,
    width: 60,
    height: 60
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M387.781 320.251c12.069-11.663 13.024-30.255 2.132-41.526-10.892-11.271-29.506-10.953-41.575.71-12.069 11.663-13.024 30.255-2.132 41.526 10.892 11.271 29.506 10.953 41.575-.71z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.84 310.34l-5.43-1.77s-5.91 13-7.84 13.78c-2.64 1-8 3.81-11.31 4.48a5.883 5.883 0 0 0-.9 2.83c4.58 1.18 14.21-1.42 16.18-3.11 4.46-3.84 9.3-16.21 9.3-16.21z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.57 302.41c.88 3.64-7.16 13.95-7.16 13.95l-6.51-4.12a32.665 32.665 0 0 1 4.89-9.75c2.68-3.33 7.81-4.07 8.78-.08z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M362.57 302.41c.88 3.64-7.16 13.95-7.16 13.95l-6.51-4.12a32.665 32.665 0 0 1 4.89-9.75c2.68-3.33 7.81-4.07 8.78-.08z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.49 306.94c.61 2.52.06 6.55-1.55 10-1.43-2.17-3.1-7.34 1.55-10z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.4 302c-1.14 4.17-3.37 15.12-1.55 32.31h19.54c.45-3.27-.13-19.24 4.46-34.65a52.091 52.091 0 0 0-7.05-.9 78.24 78.24 0 0 0-9.06 0 22.008 22.008 0 0 0-3.81.7 3.638 3.638 0 0 0-2.53 2.54z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M357.4 302c-1.14 4.17-3.37 15.12-1.55 32.31h19.54c.45-3.27-.13-19.24 4.46-34.65a52.091 52.091 0 0 0-7.05-.9 78.24 78.24 0 0 0-9.06 0 22.008 22.008 0 0 0-3.81.7 3.638 3.638 0 0 0-2.53 2.54z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M374.94 306.69c-.59 2.54-1.11 8.57 1.34 12.35a105.17 105.17 0 0 1 3.14-17.9c-1.42-.14-3.92 3.17-4.48 5.55z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.69 306.56l-1.07.47-.82-.74a6.717 6.717 0 0 1-2.09-7.29 19.539 19.539 0 0 1 2-.29 78.24 78.24 0 0 1 9.06 0c.7 0 1.4.09 2.08.16l-.68.87a25.108 25.108 0 0 1-8.48 6.82z",
    fill: "#fff",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.41 290.23c-.85 2.92-1.47 6.53.39 8.48a23.248 23.248 0 0 1-7.74 6.21 4.933 4.933 0 0 1-1.32-6.21c3.33-.78 3.53-4.8 3.17-7.06l5.5-1.42z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M366.91 291.65a8.833 8.833 0 0 1-.47 4.78 5.539 5.539 0 0 0 1.5-.44c1.91-.87 2.94-2.23 4.07-4.24.12-.52.25-1 .4-1.52l-5.5 1.42z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.18 289a3.323 3.323 0 0 0 1.84 2c1.17.5 2-.57 1.92-1.8-.08-1.23-.81-2.71-2.09-2.69a1.853 1.853 0 0 0-1.465.822 1.865 1.865 0 0 0-.205 1.668z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M362.18 289a3.323 3.323 0 0 0 1.84 2c1.17.5 2-.57 1.92-1.8-.08-1.23-.81-2.71-2.09-2.69a1.853 1.853 0 0 0-1.465.822 1.865 1.865 0 0 0-.205 1.668z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81 282.11c-.38-2.61-3.28.38-3.61 2.29-.33 1.91 1.27 3.84 2.36 2 1.09-1.84 1.44-2.88 1.25-4.29z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71 286.64c-1.25 3.87-1.79 6.17-4.24 7.84a4.866 4.866 0 0 1-5.246.431 4.872 4.872 0 0 1-2.574-4.591c.1-3.66 2.13-9.37 6.27-10.27 4.14-.9 7.08 2.72 5.79 6.59z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82 290.69c-1.5-1-1.77-1.38-1-2.28 1.3-1.46-.63-1.67.39-3.48 1.42-2.52-3.11-.75-3.19-2.58-.07-1.49-4 1.19-4.41-.53-.59-2.58 3.19-2.1 3.85-3.36.66-1.26 4.54-1.45 5.16.39.62 1.84 2.57.37 3.84 2.61 1.27 2.24-1.36 2.41-.09 4.59 1 1.75-.93 3-2.3 4.39-.82.9-1.32.88-2.25.25z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.56 290.72a4.116 4.116 0 0 1-2.58 1.47c-1.32.18-1.68-1-1.06-2.19.62-1.19 1.9-2.36 3.1-2 1.2.36 1.35 1.73.54 2.72z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64 286.72c-.08.32-.31.54-.51.51-.2-.03-.3-.32-.22-.64.08-.32.31-.55.52-.51.21.04.3.32.21.64zM365.14 286.1c-.09.32-.32.55-.52.51-.2-.04-.3-.32-.22-.64.08-.32.32-.54.52-.51.2.03.3.32.22.64z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.21 286.46a13.108 13.108 0 0 1-2.19 2.46 1.7 1.7 0 0 0 1.41.54l.78-3z",
    fill: "#ED893E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.1 290.5a.08.08 0 0 1-.06-.11.103.103 0 0 1 .039-.062.106.106 0 0 1 .071-.018 2.723 2.723 0 0 0 2.26-.63.098.098 0 0 1 .03-.02.084.084 0 0 1 .035-.007c.012 0 .024.002.035.007a.098.098 0 0 1 .03.02.098.098 0 0 1 .02.03.084.084 0 0 1 .007.035.084.084 0 0 1-.007.035.098.098 0 0 1-.02.03 2.879 2.879 0 0 1-2.44.69zM370 285.74a.156.156 0 0 1-.074-.033.155.155 0 0 1-.046-.067 1.34 1.34 0 0 0-1-.83.17.17 0 0 1-.15-.2.213.213 0 0 1 .078-.127.212.212 0 0 1 .142-.043 1.659 1.659 0 0 1 1.29 1c.017.048.015.1-.006.147a.198.198 0 0 1-.104.103.173.173 0 0 1-.13.05zM363.89 284.55a.138.138 0 0 1-.07 0 .178.178 0 0 1 0-.26 2.002 2.002 0 0 1 1.62-.73.175.175 0 0 1 .067.025.17.17 0 0 1 .081.114.17.17 0 0 1 .002.071.213.213 0 0 1-.078.127.212.212 0 0 1-.142.043 1.631 1.631 0 0 0-.708.148 1.639 1.639 0 0 0-.572.442.203.203 0 0 1-.2.02z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 305.41l-5.56 2.12s3.39 13.27 2.29 15.05c-1.5 2.43-4.17 7.85-6.44 10.41.1.963.471 1.879 1.07 2.64 4.49-2 10.74-10 11.29-12.47 1.23-5.65-2.65-17.75-2.65-17.75z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 299.83c3.55 1.13 4.52 14.66 4.52 14.66l-9.3 1.44a68.4 68.4 0 0 1-1.94-9.75c-.58-5.04 2.9-7.56 6.72-6.35z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M381 299.83c3.55 1.13 4.52 14.66 4.52 14.66l-9.3 1.44a68.4 68.4 0 0 1-1.94-9.75c-.58-5.04 2.9-7.56 6.72-6.35z",
    fill: "#000"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M301.441 247.872c12.741-12.312 13.748-31.938 2.25-43.837-11.499-11.898-31.148-11.563-43.889.749-12.74 12.312-13.747 31.938-2.249 43.836 11.499 11.899 31.148 11.564 43.888-.748z",
    fill: "#4E667D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M300.343 246.736c12.07-11.664 13.024-30.255 2.132-41.527-10.892-11.271-29.505-10.952-41.575.711-12.069 11.663-13.023 30.255-2.131 41.526 10.891 11.271 29.505 10.953 41.574-.71z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 251,
    y: 196,
    width: 60,
    height: 60
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M300.343 246.736c12.07-11.664 13.024-30.255 2.132-41.527-10.892-11.271-29.505-10.952-41.575.711-12.069 11.663-13.023 30.255-2.131 41.526 10.891 11.271 29.505 10.953 41.574-.71z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.91 233.25c.15 2.38.27 4.78.36 7.17l.29 7.14.05.87.07.76c.08.52.14 1.06.25 1.62.21 1.1.48 2.22.8 3.34.6 2.25 1.33 4.52 2 6.76l-2.07 1a54.11 54.11 0 0 1-3.31-6.59 42.41 42.41 0 0 1-1.26-3.55 18.258 18.258 0 0 1-.49-1.9l-.17-1-.1-.92c-.53-4.84-.88-9.61-1.07-14.42l4.65-.28z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.81 228c1.82.47 2.6 8.13 2.6 8.13L287 241s-2.31-9.07-.74-11.11c1.57-2.04 2.88-2.57 5.55-1.89z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M291.52 229.72l.9 7.71-3.01 1.96 2.11-9.67z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 208.28c-3.13.45-9.68 15.41 1 22.39s18.56-.95 18.56-.95-6.5-7.72-5.56-12.76c.94-5.04 5-11.39-3.32-13.51-5.86-1.45-13.74-.05-10.68 4.83z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.81 228s2.09.76-4 27.24h-18.35c.82-7.46 1.14-12.06-1.38-27.37a55.279 55.279 0 0 1 7.86-1c2.77-.195 5.55-.195 8.32 0 3.55.31 7.55 1.13 7.55 1.13z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M269.18 233.94c1.63.41 3 2.22 2.63 5.56a8.661 8.661 0 0 1-1.82 4.2c-.11-2.57-.4-5.55-.92-9.36l.11-.4z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.89 232.72s-3.17 2.48-3.35 5.11c-2.37-1.83-5.4-6.81-5.53-10a.997.997 0 0 1 1-1c.225-.017.449-.047.67-.09a.616.616 0 0 1 .53.13l6.68 5.85zM282.89 232.72a6.205 6.205 0 0 1 2.91 4.91c2.66-1.85 1.75-7.38.52-10.09a1.314 1.314 0 0 0-1.07-.77c-.36 0-.64-.09-.83-.13a.264.264 0 0 0-.197.043.267.267 0 0 0-.113.167l-1.22 5.87z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4 217.48c.34 2.68.53 7.59-1.46 9.37a21.26 21.26 0 0 0 6.95 5.87c3.92-3 1.37-5.87 1.37-5.87-2.94-.71-2.71-2.92-2.05-5l-4.81-4.37z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M279.36 219.26l2.85 2.58a8.849 8.849 0 0 0-.36 1.48c-1.13-.17-2.85-1.14-3-2.38a3.79 3.79 0 0 1 .51-1.68z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21 213.18c.94 4.31 1.25 6.15 3.83 7.9a6.002 6.002 0 0 0 8.396-1.47 6.001 6.001 0 0 0 1.054-2.94c.35-4.13-1.25-10.48-5.85-11.26a6.545 6.545 0 0 0-5.744 1.945 6.548 6.548 0 0 0-1.686 5.825z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.44 217.06c2.77-2.64 2.87-5.91 2.17-6.93 2.38-.2 8.54-1.7 7.55-4-.99-2.3-10.58-3.54-11.9 2.34-3.18 2.66-1.15 7.99 2.18 8.59zM280.45 212.79c.06.36.29.6.53.55.24-.05.38-.38.32-.73s-.29-.61-.52-.55c-.23.06-.38.38-.33.73zM284.53 211.9c.05.36.29.6.52.55.23-.05.39-.38.33-.74s-.29-.6-.52-.55a.62.62 0 0 0-.33.74z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.75 211.21l.83-.44s-.34.76-.83.44z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.37 212.82a8.988 8.988 0 0 0 1.63 2 1.67 1.67 0 0 1-1.25.52l-.38-2.52z",
    fill: "#FF5652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 217.14c.181-.01.362-.033.54-.07a.117.117 0 0 0 .069-.048.12.12 0 0 0 .009-.122.093.093 0 0 0-.067-.045.095.095 0 0 0-.041.005 2.742 2.742 0 0 1-2.5-.59.11.11 0 0 0-.175.034.098.098 0 0 0 0 .082.094.094 0 0 0 .025.034 2.767 2.767 0 0 0 2.14.72z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.63 217.48a3.007 3.007 0 0 0 2 1.37c1.12.21 1.65-.83 1.32-1.84-.33-1.01-1.24-2.11-2.35-1.86a1.539 1.539 0 0 0-.97 2.33z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.54 212a.217.217 0 0 0 .122-.055.216.216 0 0 0 .068-.115 2.762 2.762 0 0 1 1.44-1.52.207.207 0 0 0 .072-.048.21.21 0 0 0 .065-.157.226.226 0 0 0-.017-.085.188.188 0 0 0-.046-.065.193.193 0 0 0-.068-.042.193.193 0 0 0-.156.007 3.21 3.21 0 0 0-1.71 1.83.2.2 0 0 0 .16.25.085.085 0 0 0 .035.008.085.085 0 0 0 .035-.008zM285.52 209.06a.235.235 0 0 0 .107-.026.236.236 0 0 0 .083-.074.22.22 0 0 0 0-.3 2.115 2.115 0 0 0-1.92-.25.23.23 0 0 0-.13.28.208.208 0 0 0 .197.137.212.212 0 0 0 .083-.017 1.623 1.623 0 0 1 1.51.21l.07.04zM280.68 212.1l.83-.44s-.35.77-.83.44z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.26 254.17l-.58 1.64c-.08.13.07.26.28.26h18.86c.17 0 .31-.08.33-.19l.27-1.64c0-.11-.11-.21-.3-.21h-18.55a.344.344 0 0 0-.173.03.342.342 0 0 0-.137.11z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M269.26 254.17l-.58 1.64c-.08.13.07.26.28.26h18.86c.17 0 .31-.08.33-.19l.27-1.64c0-.11-.11-.21-.3-.21h-18.55a.344.344 0 0 0-.173.03.342.342 0 0 0-.137.11z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.67 256.24h-.5c-.1 0-.17-.05-.16-.11l.38-2.13c0-.06.1-.11.2-.11h.5c.1 0 .17.05.16.11l-.38 2.13c-.01.06-.1.11-.2.11z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M271.67 256.24h-.5c-.1 0-.17-.05-.16-.11l.38-2.13c0-.06.1-.11.2-.11h.5c.1 0 .17.05.16.11l-.38 2.13c-.01.06-.1.11-.2.11z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.41 256.24h-.5c-.1 0-.17-.05-.16-.11l.38-2.13c0-.06.1-.11.2-.11h.5c.1 0 .17.05.16.11l-.38 2.13c-.01.06-.1.11-.2.11z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M286.41 256.24h-.5c-.1 0-.17-.05-.16-.11l.38-2.13c0-.06.1-.11.2-.11h.5c.1 0 .17.05.16.11l-.38 2.13c-.01.06-.1.11-.2.11z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07 256.24h-.5c-.1 0-.17-.05-.16-.11l.38-2.13c0-.06.1-.11.2-.11h.5c.1 0 .17.05.16.11l-.38 2.13c-.01.06-.1.11-.2.11z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M279.07 256.24h-.5c-.1 0-.17-.05-.16-.11l.38-2.13c0-.06.1-.11.2-.11h.5c.1 0 .17.05.16.11l-.38 2.13c-.01.06-.1.11-.2.11z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.12 234c-.52 3-1.11 6.09-1.71 9.13-.29 1.52-.62 3-.94 4.55l-.47 2.27-.21 1a.332.332 0 0 0 0 .22c.163.421.424.798.76 1.1.465.454.974.859 1.52 1.21a30.208 30.208 0 0 0 3.83 2.07c1.35.63 2.75 1.21 4.17 1.74s2.87 1 4.3 1.52l-.52 2.23a55.485 55.485 0 0 1-9.23-2.34 28.33 28.33 0 0 1-4.51-2 14.228 14.228 0 0 1-2.21-1.52 6.62 6.62 0 0 1-2-2.62 4.516 4.516 0 0 1-.28-2c.05-.43.07-.52.1-.73l.09-.58.35-2.29c.25-1.53.47-3.06.74-4.59.51-3.05 1-6.1 1.63-9.14l4.59.77z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 227.88c-1.87.56-4.51 6.88-4.51 6.88l6 6.61s3.76-6.8 3.16-9.17c-.6-2.37-2.51-4.96-4.65-4.32z",
    fill: "#4E667D"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M257.32 149.85H329a2.679 2.679 0 0 0 2.63-2.47 2.26 2.26 0 0 0-.604-1.741 2.286 2.286 0 0 0-1.696-.719h-71.67a2.689 2.689 0 0 0-2.64 2.46 2.272 2.272 0 0 0 1.375 2.286c.292.125.607.188.925.184zM277.12 160.69h51.11a2.7 2.7 0 0 0 2.64-2.47 2.26 2.26 0 0 0-.604-1.741 2.286 2.286 0 0 0-1.696-.719h-51.11a2.689 2.689 0 0 0-2.64 2.46 2.289 2.289 0 0 0 .603 1.744 2.28 2.28 0 0 0 1.697.726z",
    fill: "#4E667D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M289.06 139h40.66a2.67 2.67 0 0 0 2.63-2.46 2.273 2.273 0 0 0-.6-1.74 2.267 2.267 0 0 0-1.69-.73H289.4a2.677 2.677 0 0 0-2.63 2.47 2.263 2.263 0 0 0 1.369 2.277c.291.125.605.187.921.183z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M289.15 308.23h29a2.273 2.273 0 0 1 2.3 2.46 2.68 2.68 0 0 1-2.64 2.47h-29a2.278 2.278 0 0 1-2.183-1.534 2.306 2.306 0 0 1-.117-.936 2.683 2.683 0 0 1 2.64-2.46zM249.88 308.23h29a2.273 2.273 0 0 1 2.3 2.46 2.7 2.7 0 0 1-2.64 2.47h-29a2.278 2.278 0 0 1-2.183-1.534 2.272 2.272 0 0 1-.117-.936 2.67 2.67 0 0 1 2.64-2.46zM267.76 297.39h51.11a2.273 2.273 0 0 1 2.3 2.46 2.682 2.682 0 0 1-2.63 2.47h-51.12a2.276 2.276 0 0 1-2.177-1.535 2.282 2.282 0 0 1-.113-.935 2.667 2.667 0 0 1 2.63-2.46z",
    fill: "#4E667D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M261 286.54h58.6a2.276 2.276 0 0 1 2.177 1.535c.102.3.141.619.113.935a2.667 2.667 0 0 1-2.63 2.46h-58.57a2.273 2.273 0 0 1-2.3-2.46 2.68 2.68 0 0 1 2.61-2.47z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M382.8 234.7h-53.4a2.677 2.677 0 0 0-2.63 2.47 2.263 2.263 0 0 0 1.369 2.277c.291.125.605.187.921.183h53.4a2.67 2.67 0 0 0 2.63-2.46 2.282 2.282 0 0 0-.596-1.744 2.286 2.286 0 0 0-1.694-.726zM355.34 223.86h-25.2a2.679 2.679 0 0 0-2.63 2.47 2.26 2.26 0 0 0 .604 1.741 2.276 2.276 0 0 0 1.696.719H355a2.689 2.689 0 0 0 2.64-2.46 2.272 2.272 0 0 0-1.375-2.286 2.278 2.278 0 0 0-.925-.184z",
    fill: "#4E667D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M370.09 213h-39.2a2.689 2.689 0 0 0-2.64 2.46 2.289 2.289 0 0 0 .603 1.744 2.294 2.294 0 0 0 1.697.726h39.21a2.668 2.668 0 0 0 2.63-2.47 2.26 2.26 0 0 0-.604-1.741 2.276 2.276 0 0 0-1.696-.719z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M401.8 223.86H366a2.7 2.7 0 0 0-2.64 2.47 2.26 2.26 0 0 0 .604 1.741 2.286 2.286 0 0 0 1.696.719h35.8a2.689 2.689 0 0 0 2.64-2.46 2.272 2.272 0 0 0-1.375-2.286 2.278 2.278 0 0 0-.925-.184zM240.81 121.6h26.78l-1.42-23.73-25.36 23.73z",
    fill: "#4E667D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M240.81 121.6l28.67-3.43-3.31-20.3-25.36 23.73z",
    fill: "#4E667D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M132.78 191.9c-.85 2-1.79 4.22-2.62 6.36-.83 2.14-1.68 4.33-2.45 6.5a103.558 103.558 0 0 0-3.85 13c-.14.54-.21 1.07-.31 1.6l-.14.8-.11.63c-.099.89-.119 1.787-.06 2.68a57.31 57.31 0 0 0 .89 6.51c.86 4.49 2 9.14 3.13 13.7l-5.08 2.15a83.021 83.021 0 0 1-6.36-13.55 47.408 47.408 0 0 1-2.11-7.6 20.966 20.966 0 0 1-.39-4.52v-.65-.52l.1-1c.07-.65.11-1.32.22-2a90.18 90.18 0 0 1 3.49-14.86c.78-2.39 1.58-4.75 2.51-7.06.93-2.31 1.83-4.58 3-6.95l10.14 4.78z",
    fill: "#7F3E3B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M127.09 242.44l3.9 3.8-8.51 4s-2.06-3.6-.64-6.86l5.25-.94z",
    fill: "#7F3E3B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M134.13 251.91l-7.18 2.94-4.47-4.65 8.51-3.96 3.14 5.67z",
    fill: "#7F3E3B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M319.796 230.033c11.236-27.125-1.645-58.222-28.769-69.457-27.125-11.236-58.222 1.645-69.457 28.77-11.236 27.124 1.645 58.221 28.77 69.457 27.124 11.235 58.221-1.646 69.456-28.77z",
    fill: "#4E667D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M270.68 260.05c27.813 0 50.36-22.547 50.36-50.36s-22.547-50.36-50.36-50.36-50.36 22.547-50.36 50.36 22.547 50.36 50.36 50.36z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 220,
    y: 159,
    width: 102,
    height: 102
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M270.68 260.05c27.813 0 50.36-22.547 50.36-50.36s-22.547-50.36-50.36-50.36-50.36 22.547-50.36 50.36 22.547 50.36 50.36 50.36z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.54 221.28c.56 4.12 1 8.26 1.49 12.39l1.36 12.33.18 1.48.21 1.33.29 1.38.35 1.41c.52 1.89 1.11 3.81 1.77 5.73 1.28 3.85 2.78 7.71 4.25 11.55l-3.44 1.86a100.379 100.379 0 0 1-6.38-11.08c-.93-1.94-1.82-3.91-2.58-6l-.56-1.58-.5-1.65c-.15-.57-.28-1.16-.42-1.74l-.31-1.6c-.77-4.18-1.4-8.3-2-12.44-.6-4.14-1.13-8.28-1.57-12.44l7.86-.93z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.05 212.57c3.19.81 5.42 13.94 5.42 13.94l-12.19 8.29s-5-15.56-2.57-19.06c2.56-3.65 4.69-4.35 9.34-3.17z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M289.77 215.5l2.45 13.23-4.94 3.35 2.49-16.58z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.91 178.75c-5.3.77-14.79 26.42 4.36 38.39 19.15 11.97 31.73-1.63 31.73-1.63s-12.05-13.25-11-21.89c1.05-8.64 7.24-19.53-7.28-23.16-10.29-2.57-23.62-.09-17.81 8.29z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.05 212.57s3.69 1.3-3.69 46.7h-31.43c.53-12.79.54-20.67-5.57-46.92a91.598 91.598 0 0 1 13.34-1.76c4.75-.345 9.52-.345 14.27 0 6.13.56 13.08 1.98 13.08 1.98z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M252 222.74c2.85.71 5.48 3.81 5.16 9.53a13.751 13.751 0 0 1-2.62 7.2c-.5-4.4-1.35-9.5-2.68-16l.14-.73z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.32 220.65s-5.15 4.24-5.15 8.75c-4.28-3.13-10.05-11.67-10.66-17.13a1.656 1.656 0 0 1 .4-1.223 1.653 1.653 0 0 1 1.16-.557 7.555 7.555 0 0 0 1.14-.15 1.082 1.082 0 0 1 .92.23l12.19 10.08zM275.32 220.65a11.612 11.612 0 0 1 5.57 8.41c4.33-3.17 2.12-12.65-.29-17.29a2.493 2.493 0 0 0-1.93-1.32c-.64-.08-1.12-.16-1.44-.23a.435.435 0 0 0-.336.074.431.431 0 0 0-.174.296l-1.4 10.06z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.12 194.52c.9 4.59 1.8 13-1.42 16.07a40.41 40.41 0 0 0 12.62 10.06c6.37-5.08 1.65-10.06 1.65-10.06-5.12-1.22-5-5-4.09-8.59l-8.76-7.48z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M267.69 197.57l5.18 4.43a15.067 15.067 0 0 0-.44 2.53c-1.95-.28-5-1.95-5.45-4.08a6.099 6.099 0 0 1 .71-2.88z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42 187.15c2.12 7.38 2.86 10.54 7.5 13.55 7 4.51 15.57.29 15.69-7.58.11-7.08-3.38-18-11.36-19.31a10.477 10.477 0 0 0-12.027 8.071 10.47 10.47 0 0 0 .197 5.269z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 193.8c4.45-4.54 4.23-10.14 2.91-11.89 4.06-.34 14.45-2.91 12.48-6.84-1.97-3.93-18.55-6.07-20.13 4-5.15 4.55-1.05 13.7 4.74 14.73zM268.79 186.48c.14.61.57 1 1 .94.43-.06.61-.65.48-1.26s-.57-1-1-.94c-.43.06-.61.65-.48 1.26zM275.68 185c.14.61.57 1 1 .94.43-.06.61-.65.47-1.26s-.57-1-1-.95c-.43.05-.6.61-.47 1.27z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276 183.76l1.37-.75s-.51 1.31-1.37.75z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.8 186.52a16.642 16.642 0 0 0 3 3.4 2.673 2.673 0 0 1-2.08.89l-.92-4.29z",
    fill: "#FF5652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 193.94c.309-.021.617-.064.92-.13a.19.19 0 0 0 .14-.22.19.19 0 0 0-.22-.14 5 5 0 0 1-4.36-1 .19.19 0 0 0-.301.059.178.178 0 0 0 .041.201 5.134 5.134 0 0 0 3.78 1.23z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.93 194.51a5.576 5.576 0 0 0 3.58 2.35c1.94.36 2.73-1.41 2-3.15-.62-1.56-2.37-3.62-4.24-3.2a2.525 2.525 0 0 0-1.744 1.64 2.534 2.534 0 0 0 .404 2.36z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.42 185.14a.361.361 0 0 0 .31-.29 4.34 4.34 0 0 1 2.29-2.62.365.365 0 0 0 .195-.206.364.364 0 0 0-.015-.284.359.359 0 0 0-.49-.17 4.995 4.995 0 0 0-2.7 3.15.352.352 0 0 0 .058.27.35.35 0 0 0 .101.098c.04.026.084.044.131.052.039.01.081.01.12 0zM277 180.07a.367.367 0 0 0 .235-.054.364.364 0 0 0 .142-.433.36.36 0 0 0-.157-.183 3.617 3.617 0 0 0-3.32-.43.372.372 0 0 0-.193.201.374.374 0 0 0 .083.397.357.357 0 0 0 .4.072 2.908 2.908 0 0 1 2.63.37.3.3 0 0 0 .18.06zM269.1 185.29l1.37-.75s-.47 1.31-1.37.75z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.46 257.43l-.81 2.81c-.1.22.15.44.52.44h32.34c.28 0 .52-.14.54-.31l.28-2.82c0-.19-.23-.36-.54-.36H255a.569.569 0 0 0-.54.24z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M254.46 257.43l-.81 2.81c-.1.22.15.44.52.44h32.34c.28 0 .52-.14.54-.31l.28-2.82c0-.19-.23-.36-.54-.36H255a.569.569 0 0 0-.54.24z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.84 261H258c-.17 0-.3-.09-.29-.2l.4-3.65c0-.11.16-.2.33-.2h.85c.17 0 .3.09.29.2l-.4 3.65c-.02.1-.18.2-.34.2z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M258.84 261H258c-.17 0-.3-.09-.29-.2l.4-3.65c0-.11.16-.2.33-.2h.85c.17 0 .3.09.29.2l-.4 3.65c-.02.1-.18.2-.34.2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.12 261h-.86c-.17 0-.3-.09-.28-.2l.4-3.65c0-.11.16-.2.33-.2h.85c.17 0 .3.09.29.2l-.4 3.65a.32.32 0 0 1-.33.2z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M284.12 261h-.86c-.17 0-.3-.09-.28-.2l.4-3.65c0-.11.16-.2.33-.2h.85c.17 0 .3.09.29.2l-.4 3.65a.32.32 0 0 1-.33.2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.53 261h-.85c-.17 0-.3-.09-.29-.2l.4-3.65c0-.11.16-.2.33-.2h.88c.17 0 .3.09.29.2l-.4 3.65c-.04.1-.19.2-.36.2z",
    fill: "#4E667D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M271.53 261h-.85c-.17 0-.3-.09-.29-.2l.4-3.65c0-.11.16-.2.33-.2h.88c.17 0 .3.09.29.2l-.4 3.65c-.04.1-.19.2-.36.2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.56 222.56c-.26 2.66-.59 5.32-.88 8l-1 8c-.32 2.65-.74 5.3-1.1 8l-.57 4-.18 1.26c.011.196.066.387.16.56a7.138 7.138 0 0 0 1.69 2 23.57 23.57 0 0 0 2.82 2 57.432 57.432 0 0 0 6.71 3.5c2.36 1.07 4.79 2 7.26 2.93 2.47.93 5 1.78 7.45 2.59l-.88 3.82a99.867 99.867 0 0 1-15.95-3.94 52.361 52.361 0 0 1-7.82-3.28 27.048 27.048 0 0 1-3.84-2.43 13.457 13.457 0 0 1-3.6-3.93 8.647 8.647 0 0 1-1-3.25c0-.31-.05-.62 0-.93.05-.31 0-.7.05-.8l.09-1 .34-4c.25-2.66.44-5.33.73-8l.81-8c.32-2.66.59-5.32.94-8l7.77.9z",
    fill: "#FF8B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.36 212.35c-3.15 1-6.93 11.8-6.93 11.8l11 11.34s5.65-11.66 4.32-15.73c-1.35-4.24-4.75-8.51-8.39-7.41z",
    fill: "#4E667D"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222.52 222.66a49.864 49.864 0 0 1 17.74-52.495 49.875 49.875 0 0 1 55.288-3.7 49.874 49.874 0 0 1 12.667 76.051 49.87 49.87 0 0 1-85.695-19.856z",
    fill: "#4E667D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M306.82 175.32l-41.07 84c3.523.36 7.074.329 10.59-.09l36.93-75.5a49.253 49.253 0 0 0-6.45-8.41zm12 21.38l-.27-1-29.49 60.32a49.883 49.883 0 0 0 29.76-59.32zm-61.13-35.17a49.883 49.883 0 0 0-34.53 63.348 49.885 49.885 0 0 0 14.53 22.232L280 160.68a49.628 49.628 0 0 0-22.31.85z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M214.56 204.27l-1-.1c.16-1.71.41-3.43.73-5.11l1 .19c-.29 1.65-.56 3.34-.73 5.02zm1.94-10.15l-1-.28a58.113 58.113 0 0 1 5.5-12.75l.87.5a57.085 57.085 0 0 0-5.37 12.53z",
    fill: "#4E667D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M322.66 195.67a53.838 53.838 0 0 0-75.859-34.25 53.841 53.841 0 1 0 77.262 55.216 53.841 53.841 0 0 0-1.403-20.966zm-100.14 27a49.864 49.864 0 0 1 17.74-52.495 49.875 49.875 0 0 1 55.288-3.7 49.874 49.874 0 0 1 12.667 76.051 49.87 49.87 0 0 1-85.695-19.866v.01z",
    fill: "#4E667D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M223.32 230.91c0 2.29-.59 2.59-1.22 2.66l-1.81.48-3.63 1-7.26 1.92-14.55 3.73c-9.713 2.44-19.44 4.817-29.18 7.13l-29.22 7-14.59 3.54c-4.86 1.21-9.74 2.33-14.55 3.73a3.865 3.865 0 0 1-2.946-.317 3.878 3.878 0 0 1-1.859-2.308 3.865 3.865 0 0 1 .317-2.946 3.878 3.878 0 0 1 2.308-1.859h.16c4.87-1.2 9.65-2.69 14.45-4.08l14.4-4.27 28.77-8.66c9.593-2.9 19.197-5.737 28.81-8.51l14.45-4.15 7.24-2 3.62-1 1.81-.5c.58-.25 1.22-.28 2.4 1.69a14.825 14.825 0 0 1 2.08 7.72z",
    fill: "#4E667D"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M160.4 156.3c0 .59.31 1.07.7 1.07.39 0 .7-.48.7-1.07 0-.59-.31-1.08-.7-1.08-.39 0-.7.48-.7 1.08z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M160.66 157.37a21.178 21.178 0 0 0 2.82 5.07 3.408 3.408 0 0 1-2.83.53l.01-5.6z",
    fill: "#630F0F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M158.3 153a.354.354 0 0 1-.323-.457.35.35 0 0 1 .123-.173 3.496 3.496 0 0 1 3.13-.54.35.35 0 0 1 .2.45.35.35 0 0 1-.45.2 2.792 2.792 0 0 0-2.48.45.309.309 0 0 1-.2.07z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M141.32 160.13c.53 5.79.6 16.32-3.49 19.77 0 0 .93 5.91 10.87 6.83 10.93 1 5.76-5.29 5.76-5.29-5.83-2.07-5.24-6.77-3.79-11.09l-9.35-10.22z",
    fill: "#7F3E3B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M125.33 397.31c-.86.36-2.83-.51-3.46-.88a.148.148 0 0 1-.066-.067.143.143 0 0 1-.014-.093.172.172 0 0 1 .12-.15c.1 0 2.44-.78 3.39-.23a.813.813 0 0 1 .41.55.699.699 0 0 1-.23.79.72.72 0 0 1-.15.08zm-2.91-1c1 .5 2.43.92 2.85.62 0 0 .17-.12.1-.44a.492.492 0 0 0-.24-.32 4.726 4.726 0 0 0-2.71.16v-.02z",
    fill: "#4E667D"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M122.51 396.29a2.847 2.847 0 0 1-.51.16.148.148 0 0 1-.17-.05.191.191 0 0 1 0-.18c0-.08.81-2.06 1.83-2.48a.944.944 0 0 1 .77 0 .554.554 0 0 1 .309.221.555.555 0 0 1 .091.369c-.1.67-1.39 1.57-2.32 1.96zm-.24-.28c.9-.34 2.13-1.22 2.19-1.71 0-.05 0-.15-.2-.25a.583.583 0 0 0-.5 0c-.65.28-1.23 1.39-1.49 1.95v.01zM170.76 409.11a13.366 13.366 0 0 1-2.25-.2.18.18 0 0 1-.14-.14.162.162 0 0 1 .013-.106.162.162 0 0 1 .077-.074c.11-.07 2.67-1.53 3.9-1.2.23.059.428.206.55.41a.662.662 0 0 1 0 .76c-.29.44-1.2.55-2.15.55zm-1.69-.46c1.37.19 3.23.18 3.57-.29 0-.06.09-.17 0-.39a.512.512 0 0 0-.34-.24c-.79-.21-2.3.46-3.23.92z",
    fill: "#4E667D"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M168.54 408.91a.189.189 0 0 1-.1 0 .169.169 0 0 1-.07-.16c0-.08.21-2.06 1.14-2.83a1.317 1.317 0 0 1 1-.3c.47.05.61.29.64.49.14.83-1.62 2.42-2.5 2.82l-.11-.02zm1.8-3a.997.997 0 0 0-.61.23 4.15 4.15 0 0 0-1 2.26c.91-.54 2.1-1.79 2-2.29 0 0 0-.16-.34-.19l-.05-.01z",
    fill: "#4E667D"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M160.47 408.74h7.34l.73-17.01h-7.34l-.73 17.01zM113.67 394.7l7.22 1.36 8.13-15.79-7.22-1.35-8.13 15.78z",
    fill: "#7F3E3B"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M121.68 395.31l-7.9-2.38a.647.647 0 0 0-.423.02.646.646 0 0 0-.317.28l-3.28 5.84a1.082 1.082 0 0 0 .66 1.56c2.77.78 4.16 1 7.63 2.07 2.14.64 7.76 3 10.72 3.87 2.96.87 4.21-1.92 3.08-2.55-5.06-2.81-7.89-5.85-9.16-7.93a1.763 1.763 0 0 0-1.01-.78zM167.76 407.89h-8a.63.63 0 0 0-.62.5l-1.45 6.53a1.053 1.053 0 0 0 .208.906 1.053 1.053 0 0 0 .842.394c2.9 0 7.08-.21 10.72-.21 4.25 0 7.92.23 12.91.23 3 0 3.85-3.05 2.59-3.33-5.75-1.25-10.44-1.39-15.41-4.45a3.414 3.414 0 0 0-1.79-.57z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M124 181.77c-6.38 3-9 23.56-9 23.56l14.65 5.75a116.505 116.505 0 0 0 5.5-17.15c2.1-9.28-4.6-15.28-11.15-12.16z",
    fill: "#4E667D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M124 181.77c-6.38 3-9 23.56-9 23.56l14.65 5.75a116.505 116.505 0 0 0 5.5-17.15c2.1-9.28-4.6-15.28-11.15-12.16z",
    fill: "#000"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.53 187.8a8.23 8.23 0 0 1 1.56-.57c.584 2.193.605 4.497.06 6.7a116.505 116.505 0 0 1-5.5 17.15l-4.83-1.89c.89-5.37 3.62-18.95 8.71-21.39z",
    fill: "#000"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M166.52 181.61s7.82 8.83.43 63.5h-39.29c-.27-6 3.52-35.46-2.3-63.88 4.346-.836 8.742-1.39 13.16-1.66 5.562-.32 11.138-.32 16.7 0a73.431 73.431 0 0 1 11.3 2.04z",
    fill: "#4E667D"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.52 181.61s7.82 8.83.43 63.5h-39.29c-.27-6 3.52-35.46-2.3-63.88 4.346-.836 8.742-1.39 13.16-1.66 5.562-.32 11.138-.32 16.7 0a73.431 73.431 0 0 1 11.3 2.04z",
    fill: "#000"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.61 193.33c1.78-5.34 6.06-7.05 10.42-3.88.88 5.18 1.5 13.53.79 26.77l-7.67-.07s-6.15-14.87-3.54-22.82z",
    fill: "#000"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M171.06 189.68c.38 2.29.8 4.79 1.27 7.17s1 4.8 1.56 7.16a88.451 88.451 0 0 0 4.21 13.61c.45 1 .91 2.06 1.42 3l.65 1.18a4.5 4.5 0 0 0 .57.74 21.48 21.48 0 0 0 5 3.54 118.585 118.585 0 0 0 13.33 5.92l-1.09 5.4a61.082 61.082 0 0 1-15.78-3.22 33.509 33.509 0 0 1-4-1.69 23.228 23.228 0 0 1-4-2.59c-.73-.6-1.4-1.27-2-2l-.48-.63-.31-.47c-.21-.31-.42-.62-.61-.93-.78-1.25-1.47-2.5-2.11-3.76a83.048 83.048 0 0 1-5.54-15.27c-.67-2.57-1.29-5.13-1.79-7.72s-1-5.12-1.3-7.88l11-1.56z",
    fill: "#7F3E3B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M156.7 187c-2.07 6.71 6.33 26.71 6.33 26.71l17.69-4.45a81.792 81.792 0 0 0-5.43-18.39c-5.74-12.48-16.1-11.96-18.59-3.87z",
    fill: "#4E667D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.7 187c-2.07 6.71 6.33 26.71 6.33 26.71l17.69-4.45a81.792 81.792 0 0 0-5.43-18.39c-5.74-12.48-16.1-11.96-18.59-3.87z",
    fill: "#000"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M199.18 232l7.59 3.41-7.36 6.07s-3.24-1.06-3.77-6.38l-1.13-4.42 3.33.85c.46.116.908.273 1.34.47z",
    fill: "#7F3E3B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M210.8 239.09l-7.39 4.41-4-2.06 7.35-6.07 4.04 3.72z",
    fill: "#7F3E3B"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M158.56 178.92c-3.17-2.68-10.87-4.61-19.49-5.09-4.93-.27-10 .54-12.11 1.48-2.11.94.39 7.73 3.15 7.88-1.46 2.3.66 6.74 3.83 7.61-.5 3.84 9.18 4.2 15 1.1 4.7-2.47 13.42-9.77 9.62-12.98z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.54 391.73l-.37 8.77h-7.35l.37-8.77h7.35zM121.79 378.92l7.23 1.36-4.19 8.13-7.23-1.36 4.19-8.13z",
    fill: "#000"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M140.64 155c.44 7.28.32 11.56 4 15.3 5.52 5.62 14.51 2.3 16.25-5 1.57-6.54.58-17.34-6.54-20.25a9.942 9.942 0 0 0-13.71 9.95z",
    fill: "#7F3E3B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M154.26 159.06c2.75-2.78 7.27-8.84 5.69-13.39-2.33-6.73-9.28-4.45-8.17-3.11-4-2.64-12.08-2.77-10.39.77-7.27 1-7.86 3.95-5.84 5.06-5.18 4.94-4.93 10.05-1 9.67-3 3 2.52 8.94 8.69 11.77 2.1-5.5 13.34-6.5 11.02-10.77z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M151.07 161.69a.256.256 0 0 1-.14 0 .256.256 0 0 1-.103-.162.247.247 0 0 1 .043-.188c1.58-2.32 3.12-4.18 4.48-5.82 2.6-3.14 4.48-5.41 4.64-8.49a6.062 6.062 0 0 0-3.92-5.85c-1.86-.84-3.86-.89-4.65-.11-.42.41-.46 1-.12 1.82a.218.218 0 0 1 .024.094.235.235 0 0 1-.071.176.243.243 0 0 1-.083.05.263.263 0 0 1-.096.021.243.243 0 0 1-.178-.07.25.25 0 0 1-.056-.081 1.994 1.994 0 0 1 .23-2.37c.94-.92 3.13-.92 5.21 0a6.531 6.531 0 0 1 4.21 6.32c-.17 3.25-2.09 5.57-4.75 8.78-1.36 1.64-2.89 3.49-4.46 5.8a.245.245 0 0 1-.096.065.245.245 0 0 1-.114.015z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M151.43 158.24a8.24 8.24 0 0 0 2.06 4.87c1.6 1.76 3.28.66 3.56-1.48.25-1.94-.27-5.19-2.23-6.16-1.96-.97-3.52.59-3.39 2.77z",
    fill: "#7F3E3B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M153 245.11s2.48 49.52-2.35 70.5c-7.65 33.22-22.28 71.75-22.28 71.75l-13.62-2.57s11.47-38.58 14-66.24c2.23-24.84-1.07-53.37-1.07-73.44H153z",
    fill: "#263238"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.33 259.78c1-1.93 2.95 3.82 4.31 11.2 0 10.18-.18 21.76-1.07 31.57-6.8-12.55-5.35-38.77-3.24-42.77z",
    fill: "#000"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M131.71 383.18c.06 0-2.13 4.72-2.13 4.72l-15.76-3.07 1.72-4.75 16.17 3.1z",
    fill: "#2C6BDB"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M167 245.11s11 46.89 11.8 69.3c.87 25.13-7.9 84.39-7.9 84.39h-12.44s-1.53-59.72-2.09-82.61c-.6-24.95-15.24-71.08-15.24-71.08H167z",
    fill: "#263238"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3 393.84c.06 0-.7 5.17-.7 5.17h-15.14l-.41-4.61 16.25-.56z",
    fill: "#2C6BDB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresultglobalsearch);
export default __webpack_public_path__ + "static/media/Noresultglobalsearch.a54d70c091ef043eaead02a49f11ce62.svg";
export { ForwardRef as ReactComponent };